import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import {
    replaceHistoryState,
    StateType,
} from "client/utils"
import { mtUsersRoute } from "client/parts/routes"
import {
    StoreType,
    UserProps,
    LoadUserById,
    setUserView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"
import AssignedAccounts from "../accounts/assigned"


const DETAILS = "#details"
const ACCOUNTS = "#accounts"

const menu = [DETAILS, ACCOUNTS]

const View = ({
    userId = null,
    hash = null,
}: UserProps) => {
    const user = useSelector((state: StoreType) => state.user.userView)
    const reloadView = useSelector((state: StoreType) => state.user.reloadView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [activeTab, setActiveTab] = useState(menu.includes(hash) ? hash : DETAILS)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadUserById(userId).then((res) => {
            dispatch(setUserView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const handleMenuClick = (tab: string) => {
        setActiveTab(tab)
        replaceHistoryState(`${mtUsersRoute}/${VIEW}/${userId}${tab}`)
    }

    if (!user) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewUser} # ${user.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageMenu>
                    <PageMenuButton
                        isActive={activeTab === DETAILS}
                        onClick={() => handleMenuClick(DETAILS)}
                    >
                        {lang.details}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === ACCOUNTS}
                        onClick={() => handleMenuClick(ACCOUNTS)}
                    >
                        {lang.accounts}
                    </PageMenuButton>
                </PageMenu>
                <Tab show={activeTab === DETAILS}>
                    {loadState === PENDING && <Loader />}
                    <Form />
                </Tab>
                <Tab show={activeTab === ACCOUNTS}>
                    <AssignedAccounts userId={userId} showHeader={false} />
                </Tab>
            </PageContent>
        </Container>
    )
}
export default View
